module.exports = __webpack_public_path__ + "img/benefits-12.b36583dc.svg";